<template>
  <b-card>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="Name"
            rules="required"
          >
            <b-form-group
              label="Name"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="engineerForm.name"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Name"
                readonly
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="Email"
            rules="required"
          >
            <b-form-group
              label="Email"
              label-for="email"
            >
              <b-form-input
                id="email"
                v-model="engineerForm.email"
                type="email"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Email"
                readonly
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="6">
          <validation-provider
            #default="validationContext"
            rules="required"
            name="Status"
          >
            <b-form-group
              label="Status "
              label-for="Status"
            >
              <b-form-checkbox-group
                id="status_id"
                v-model="engineerForm.status_id"
                class="d-flex flex-column"
                :options="optionsStatusId"
                trim
                placeholder="Status"
                :state="getValidationState(validationContext)"
                multiple
              />
              <!-- <div class="bg-black">
                Selected: <strong>{{ engineerForm.status_id }}</strong>
              </div> -->

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addUserSite()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addUserSite()"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {},
  data() {
    return {
      id: this.$store.state.generalIds.id,
      required,
      loader: false,
      validationErrors: {},
      errors: {},
      optionsStatusId: [],
    }
  },

  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const engineerForm = ref({
      name: '',
      email: '',
      status_id: [],
    })
    return {
      getValidationState,
      engineerForm,
    }
  },
  mounted() {
    this.getEngineerStatus()
    this.showEngineer()
  },
  methods: {
    getEngineerStatus() {
      this.loadtable = true
      axios
        .get('engineer-status')
        .then(res => {
          this.optionsStatusId = decryptData(res.data.payload).data.status.map(item => ({
            value: item.id,
            text: item.status,
          }))
        })
        .finally(() => {
          this.loadtable = false
        })
    },

    showEngineer() {
      if (this.$route.params.id) {
        axios.get(`/register/site/user/${this.$route.params.id}`).then(res => {
          const userData = decryptData(res.data.payload).data.user
          this.engineerForm.name = userData.name
          this.engineerForm.email = userData.email
          this.engineerForm.status_id = userData.status.map(item => item.id)
        })
      } else {
        return false
      }
      return true
    },

    addUserSite() {
      if (this.$route.params.id) {
        this.loader = true
        const formData = new FormData()
        formData.append('_method', 'PUT')

        Object.keys(this.engineerForm).forEach(key => {
          if (Array.isArray(this.engineerForm[key])) {
            this.engineerForm[key].forEach(item => {
              formData.append(`${key}[]`, item)
            })
          } else {
            formData.append(key, this.engineerForm[key])
          }
        })

        axios
          .post(`/engineer/${this.$route.params.id}`, formData)
          .then(res => {
            if (res.status === 200) {
              this.$router.push({ name: 'engineers' })
              this.$toasted.show('Updated Successfully', {
                position: 'top-center',
                duration: 3000,
              })
            }
          })
          .catch(error => {
            if (error.response.status) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `${error.response.data.message}`,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            }
          })
          .finally(() => {
            this.loader = false
          })
      }
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
